import React, { FC } from 'react';


interface Button {
  title: string;
  onClick: () => any;
  disabled?: boolean;
}

const Button: FC<Button> = ({ title, onClick, disabled = false }): JSX.Element => {
  return (
    <div onClick={onClick} className={`default-button ${disabled ? 'disabled' : ''}`}>
      <div className="button-title">{title}</div>
      <div className="button-icon">
        <img alt="" src={`${process.env.PUBLIC_URL}/assets/images/next.svg`}/>
      </div>
    </div>
  );
};

export default Button;
